.why-choose {
  padding: clamp(26px, 2vw, 40px) clamp(20px, 4.6vw, 88px);
  background: #faf8f7;
  color: #222222;
}

.why-choose__inner {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}

.why-choose__header {
  max-width: 820px;
  margin-bottom: clamp(40px, 5vw, 72px);
}

.why-choose__eyebrow {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  color: #55565a;
  font-family: "JetBrains Mono", monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.18em;
  line-height: 1.4;
  text-transform: uppercase;
}

.why-choose__eyebrow-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ff6b00;
}



.why-choose__header h2 {
  margin: 0;
  color: #222222;
  font-family: "Sora", sans-serif;
  font-size: clamp(38px, 4.2vw, 66px);
  font-weight: 600;
  letter-spacing: -0.065em;
  line-height: 1.05;
}

.why-choose__header h2 em {
  color: #ff6b00;
  font-style: normal;
}

.why-choose__intro {
  max-width: 560px;
  margin: 22px 0 0;
  color: #55565a;
  font-family: "DM Sans", sans-serif;
  font-size: clamp(15px, 1.25vw, 18px);
  line-height: 1.6;
}

.why-ledger__bar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e0dbd6;
  color: #55565a;
  font-family: "JetBrains Mono", monospace;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.why-ledger__bar-head i {
  color: #ff6b00;
  font-style: normal;
}

.why-ledger {
  --why-top: 6.5rem;
  --why-step: 14px;

  position: relative;
  margin: 0;
  padding: 0;
  list-style: none;
}

.why-ledger::after {
  display: block;
  height: clamp(40px, 12vh, 140px);
  content: "";
}

.why-ledger__row {
  position: sticky;
  top: calc(var(--why-top) + var(--i, 0) * var(--why-step));
  display: grid;
  grid-template-columns:
    clamp(110px, 16vw, 240px)
    minmax(0, 1fr)
    clamp(180px, 20vw, 280px);
  align-items: start;
  align-content: center;
  column-gap: clamp(20px, 4vw, 64px);
  box-sizing: border-box;
  min-height: var(--card-h, 0px);
  margin-bottom: clamp(20px, 3vh, 36px);
  padding: clamp(28px, 3.4vw, 48px) clamp(18px, 2.4vw, 40px);
  border: 1px solid #e8e4e1;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 -10px 28px rgba(17, 17, 17, 0.06);
  transition:
    background-color 450ms ease,
    box-shadow 450ms ease;
}

.why-ledger__row:last-child {
  margin-bottom: 0;
}

.why-ledger__row.is-active {
  background: #fffaf6;
  box-shadow:
    inset 3px 0 0 #ff6b00,
    0 -10px 28px rgba(17, 17, 17, 0.06);
}

.why-ledger__number {
  color: #e8e4e1;
  font-family: "Sora", sans-serif;
  font-size: clamp(64px, 9.5vw, 150px);
  font-weight: 500;
  letter-spacing: -0.07em;
  line-height: 0.85;
  transition: color 450ms ease;
}

.why-ledger__row.is-active .why-ledger__number {
  color: rgb(255 107 0 / 30%);
}

.why-ledger__copy {
  max-width: 640px;
  padding-top: clamp(2px, 0.6vw, 8px);
}

.why-ledger__copy h3 {
  margin: 0;
  color: #222222;
  font-family: "Sora", sans-serif;
  font-size: clamp(22px, 2.7vw, 40px);
  font-weight: 600;
  letter-spacing: -0.05em;
  line-height: 1.12;
}

.why-ledger__copy p {
  max-width: 560px;
  margin: 14px 0 0;
  color: #55565a;
  font-family: "DM Sans", sans-serif;
  font-size: clamp(14px, 1.1vw, 17px);
  line-height: 1.7;
  transition: color 450ms ease;
}

.why-ledger__row.is-active .why-ledger__copy p {
  color: #222222;
}

.why-ledger__metric {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: clamp(4px, 0.8vw, 12px);
  font-family: "JetBrains Mono", monospace;
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.why-ledger__metric-head {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #999999;
}

.why-ledger__metric-head span {
  color: #ff6b00;
}

.why-ledger__bar {
  position: relative;
  height: 2px;
  background: #e0dbd6;
}

.why-ledger__bar span {
  position: absolute;
  inset: 0;
  background: #ff6b00;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 900ms cubic-bezier(0.2, 0.75, 0.25, 1);
}

.why-ledger__row.is-done .why-ledger__bar span {
  transform: scaleX(var(--fill, 1));
}

.why-ledger__metric-foot {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  color: #55565a;
}

.why-ledger__metric-foot strong {
  color: #222222;
  font-weight: 600;
  text-align: right;
}

.why-choose__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: clamp(32px, 4vw, 52px);
}

.why-choose__button {
  display: inline-flex;
  min-height: 46px;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 0 19px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-family: "DM Sans", sans-serif;
  font-size: 13px;
  font-weight: 650;
  text-decoration: none;
  transition:
    transform 220ms ease,
    background-color 220ms ease,
    border-color 220ms ease,
    color 220ms ease;
}

.why-choose__button:hover {
  transform: translateY(-2px);
}

.why-choose__button:focus-visible {
  outline: 2px solid #ff6b00;
  outline-offset: 3px;
}

.why-choose__button--primary {
  background: #ff6b00;
  color: #ffffff;
}

.why-choose__button--primary:hover {
  background: #db4e20;
}

.why-choose__button--secondary {
  border-color: #d9d5d1;
  background: #ffffff;
  color: #222222;
}

.why-choose__button--secondary:hover {
  border-color: #222222;
}

@media (max-width: 900px) {
  .why-ledger__row {
    grid-template-columns: clamp(80px, 14vw, 120px) minmax(0, 1fr);
    row-gap: 24px;
  }

  .why-ledger__metric {
    grid-column: 2;
    max-width: 320px;
  }
}

@media (max-width: 640px) {
  .why-choose {
    padding: 44px 18px;
  }

  .why-choose__header {
    margin-bottom: 32px;
  }

  .why-choose__header h2 {
    font-size: clamp(30px, 8.4vw, 40px);
  }

  .why-ledger {
    --why-top: 5.5rem;
    --why-step: 10px;
  }

  .why-ledger__row {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 14px;
    padding: 22px 16px;
  }

  .why-ledger__number {
    font-size: 52px;
  }

  .why-ledger__copy h3 {
    font-size: 22px;
  }

  .why-ledger__metric {
    grid-column: auto;
    max-width: none;
  }

  .why-choose__button {
    min-height: 44px;
    padding: 0 15px;
    font-size: 12px;
  }
}

@media (max-height: 560px) {
  .why-ledger__row {
    position: relative;
    top: auto;
    min-height: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .why-ledger__row,
  .why-ledger__number,
  .why-ledger__copy p,
  .why-ledger__bar span,
  .why-choose__button {
    transition: none;
  }
}
